import { emailValidation } from '../../../utilities/validations/inputsValidations';
import { useTranslation } from 'react-i18next';

export default function InputEmail({ register, errors }) {
    const { t } = useTranslation();
    return (
        <>
            <input
                className='form-control'
                type="text"
                placeholder={t("Email")}
                {...register("email", { required: true, pattern: emailValidation })} />
            {errors.email && <p className='errors-msg bg-warning p-1 rounded'>
                تأكد من إدخال البريد الإلكتروني الصحيح
            </p>}
        </>
    )
}

